<div class="invitation-container">
  <div class="invitation-card">
    <div class="card-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 2v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-4 9v5m8-5v5m-8 0a3 3 0 1 0-6 0m20 0a3 3 0 1 1-6 0"/>
      </svg>
    </div>

    @if (loading) {
      <h1>{{ 'invitation.title' | t }}</h1>
      <p class="subtitle">{{ 'invitation.checking' | t }}</p>
    } @else if (invalid) {
      <h1>{{ 'invitation.expiredTitle' | t }}</h1>
      <p class="subtitle">
        {{ 'invitation.expiredText' | t }}
      </p>
      <a class="back-link" routerLink="/">{{ 'signin.backHome' | t }}</a>
    } @else {
      <h1>{{ 'invitation.treeTitle' | t }}</h1>
      <p class="subtitle">
        {{ 'invitation.intro' | t }} <b>{{ invitation?.tree_title }}</b>
        {{ 'invitation.withRights' | t }} <b>{{ membershipLevelName() | t }}</b>.
      </p>

      @if (authService.isLoggedIn()) {
        <p class="subtitle">
          {{ 'invitation.signedInAs' | t }} <b>{{ authService.loggedUser() }}</b>.
        </p>
        <button mat-raised-button color="primary" class="primary-button"
          (click)="onAccept()" [disabled]="accepting">{{ 'invitation.accept' | t }}</button>
      } @else if (showSignup) {
        <p class="subtitle">
          {{ 'invitation.creatingAccount' | t }} <b>{{ invitation?.email }}</b>.
          {{ 'invitation.noConfirm' | t }}
        </p>
        <form [formGroup]="signupForm" (ngSubmit)="onSignup()">
          <mat-form-field appearance="outline" class="input">
            <mat-label>{{ 'signup.username' | t }}</mat-label>
            <input matInput [formControl]="usernameFormControl">
            @if (usernameFormControl.hasError('required')) {
              <mat-error>{{ 'signup.usernameRequired' | t }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="input">
            <mat-label>{{ 'signup.firstName' | t }}</mat-label>
            <input matInput [formControl]="nameFormControl">
            @if (nameFormControl.hasError('required')) {
              <mat-error>{{ 'signup.firstNameRequired' | t }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="input">
            <mat-label>{{ 'signup.lastName' | t }}</mat-label>
            <input matInput [formControl]="surnameFormControl">
            @if (surnameFormControl.hasError('required')) {
              <mat-error>{{ 'signup.lastNameRequired' | t }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="input">
            <mat-label>{{ 'signup.password' | t }}</mat-label>
            <input matInput type="password" [formControl]="passwordFormControl">
            @if (passwordFormControl.hasError('minlength')) {
              <mat-error>{{ 'signup.passwordShort' | t }}</mat-error>
            }
            @if (passwordFormControl.hasError('required')) {
              <mat-error>{{ 'signin.passwordRequired' | t }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="input">
            <mat-label>{{ 'signup.passwordRepeat' | t }}</mat-label>
            <input matInput type="password" [formControl]="passwordRepeatFormControl">
          </mat-form-field>
          @if (signupForm.hasError('passwordMismatch') && passwordRepeatFormControl.value) {
            <p class="form-error">{{ 'signup.passwordMismatch' | t }}</p>
          }
          <button mat-raised-button color="primary" class="primary-button" type="submit"
            [disabled]="signupForm.invalid || accepting">{{ 'invitation.createAndJoin' | t }}</button>
        </form>
      } @else {
        <p class="subtitle">
          {{ 'invitation.sentTo' | t }} <b>{{ invitation?.email }}</b>.
          {{ 'invitation.signInOrCreate' | t }}
        </p>
        <button mat-raised-button color="primary" class="primary-button" (click)="onSignin()">{{ 'header.signIn' | t }}</button>
        <button mat-stroked-button class="secondary-button" (click)="onShowSignup()">{{ 'invitation.noAccount' | t }}</button>
        @if (facebookAvailable) {
          <div class="separator"><span>lub</span></div>
          <button mat-stroked-button class="secondary-button" (click)="onFacebook()">{{ 'signup.facebook' | t }}</button>
        }
      }
    }
  </div>
</div>
